module.exports = __webpack_public_path__ + "img/logo-asein-dark.3fb05afb.jpg";